var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.9113V21C1 22.1046 1.89543 23 3 23H7C8.10457 23 9 22.1046 9 21V17C9 15.8954 9.89543 15 11 15H14C15.1046 15 16 15.8954 16 17V21C16 22.1046 16.8954 23 18 23H22C23.1046 23 24 22.1046 24 21V10.9113C24 10.3324 23.7492 9.7819 23.3124 9.40205L13.8124 1.14118C13.0598 0.486795 11.9402 0.486795 11.1876 1.14118L1.68764 9.40205C1.25082 9.7819 1 10.3324 1 10.9113Z",
    stroke: "#7A5AF8",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.6baf99d12b3f22839cbe2c3837b6aef1.svg";
export { ForwardRef as ReactComponent };